module.exports = __webpack_public_path__ + "img/cropped-aiopenlogo_colored.a75fa3ce.png";